export const removeWrappingCommas = (value: string) => {
  const trimmed = value.trim();
  let start = 0;
  let end = trimmed.length;
  while (start < end && trimmed[start] === ',') start++;
  while (end > start && trimmed[end - 1] === ',') end--;
  return trimmed.slice(start, end);
};
